import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route } from '@angular/router';
import { Observable } from 'rxjs';
import {AuthService} from './auth.service';
import * as toastr from 'toastr';

@Injectable()
export class RoleGuard implements CanActivate {
  constructor(public auth: AuthService, public router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const routeUrl = route.routeConfig.path;

    if (!this.auth.isAuthenticated()) {
      if (routeUrl !== '' && routeUrl !== 'login') {
        console.error('Login before access');
      }

      if (routeUrl !== 'login') {
        this.router.navigate(['login']);
      } else {
        return true;
      }
    }

    if (routeUrl === 'login') {
      this.router.navigate(['contractual-data']);
    }

    if (!this.auth.isPageAvailable()) {
      toastr.warning('Unauthorized', '403');
      this.router.navigate(['login']);
      return false;
    }

    return true;
  }
}

